export default __webpack_public_path__ + "static/O0230-011220f69e6d49004dc5ca1ecf0ab234.png";